// @ts-nocheck
import classNames from 'clsx'
import { ComponentType, FC, SVGProps } from 'react'

import colors from 'shared/config/cssVars/colors'
import { filterKeys, filterValues, mapValues } from 'shared/utils/objectUtils'

import 'views/components/atoms/IconImage/Icon.scss'

interface IconInlineNativeProps {
  alt: string
  component: ComponentType<SVGProps<SVGSVGElement>>
  size?: string
  className?: string
  color?: string
  fill?: string
  stroke?: string
  strokeWidth?: number
}
export type IconInlineProps = IconInlineNativeProps & {
  [dataAttrName: string]: string
}

const IconInline: FC<IconInlineProps> = ({
  alt,
  component,
  size = 'default',
  className,
  color,
  fill,
  stroke,
  strokeWidth,
  children,
  ...dataAttrs
}) => {
  const ariaLabel = alt || undefined
  const ariaHidden = alt ? undefined : 'true'

  const IconComponent = component

  const iconClassName = classNames(
    'a-Icon',
    size === 'default' ? null : `a-Icon--${size}`,
    className
  )

  const onlyDataAttrs = filterKeys<GenericRecord<string>>(
    (key: string) => key.startsWith('data-'),
    dataAttrs
  )

  const colorProps = filterValues((val?: string) => val != null, {
    color,
    fill,
    stroke,
  })
  const svgProps = mapValues(v => (v && colors[v] ? colors[v] : v), colorProps)
  if (strokeWidth) {
    svgProps.style = `stroke-width:${strokeWidth}`
  }

  return (
    <IconComponent
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
      className={iconClassName}
      {...svgProps}
      {...onlyDataAttrs}
    >
      {children}
    </IconComponent>
  )
}

export default IconInline
